import { HeaderNotification } from '@core/domain/model/notifications/notification.model';

export type AppState = {
  showLoading: boolean;
  specificLoading: string[];
  visitedHeaderNotifications: Partial<Record<HeaderNotification, true>>;
  blockedScroll: boolean;
  cookiesConsent?: AppCookiesConsentState;
};

export type AppCookiesConsentState = {
  necessary: boolean;
  preferences: boolean;
  statistics: boolean;
  marketing: boolean;
};

export const appInitialState: AppState = {
  showLoading: false,
  specificLoading: [],
  visitedHeaderNotifications: {},
  blockedScroll: false,
};
